/**
 * @param { array } links - [array] list of available links.
 * @param { number } linkType - [number] id value of link to be found.
 * @returns { object } object of desired link if found, otherwise returns null.
 */
export const findLinkById = ({ links, linkType }) => {
    if (!links || !linkType) return null;
    const link = links?.find(
        (link) => link.id === parseInt(linkType) && link.link !== ""
    );
    return link && link.link !== null ? link : null;
};

/**
 * @param { array } links - [array] list of available links.
 * @param { string } linkType - [string] name value of link to be found.
 * @param { string } from - [string] debugging, location of where function was called.
 * @returns { object } object of desired link if found, otherwise returns null.
 */
export const findLinkByName = ({ links, linkType }) => {
    if (!links || !linkType) return null;
    const link = links?.find(
        (link) => link.name === linkType && link.link !== ""
    );

    return link && link.link !== null ? link : null;
};

/**
 * @param { array } links - [object] list of available interactive links.
 * @param { string } clickId - [string] click id value of link to be found.
 * @returns { object } object of desired link if found, otherwise returns null.
 */
 export const findInteractiveVideoLink = ({ use_interactive_video, links, clickId }) => {
    if(!use_interactive_video || !links) return null;

    if(links[clickId]) return links[clickId];
    if(links["generic"]) return links["generic"];
    return null;
};
